<div [class.over]="dragoverflag" (drop)="dropFiles($event)" (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)">
    <ng-content></ng-content>
</div>